module.exports = __webpack_public_path__ + "img/File-pdf.a699ee62.svg";